<template>
  <el-card class="box-card">
    <el-form>
      <el-row>
        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="路径" :label-width="formLabelWidth" prop="path">
            <el-input v-model="path" placeholder="请输入路径" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="包路径" :label-width="formLabelWidth" prop="packagePath">
            <el-input v-model="packagePath" placeholder="请输入包路径" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="Vue路径" :label-width="formLabelWidth" prop="vuePath">
            <el-input v-model="vuePath" placeholder="请输入Vue路径" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="组件路径" :label-width="formLabelWidth" prop="ComponentPath">
            <el-input v-model="componentPath" placeholder="请输入组件路径" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="作者" :label-width="formLabelWidth" prop="author">
            <el-input v-model="author" placeholder="请输入作者" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="角色" :label-width="formLabelWidth" prop="role_list">
            <el-select v-model="role" placeholder="请选择角色" multiple>
              <el-option v-for="role in role_list" :key="role.roleName" :value="role.roleName" :label="role.roleName"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="业务名称" :label-width="formLabelWidth" prop="bizName">
            <el-input v-model="bizName" placeholder="请输入业务名称" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="实体" :label-width="formLabelWidth" prop="entityName">
            <el-input v-model="entityName" placeholder="请输入实体" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-for="(field, index) in fieldList" :key="index">
        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item :label="'字段' + (index + 1)" :label-width="formLabelWidth">
            <el-input v-model="fieldList[index].field" placeholder="请输入实体属性" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item>
            <el-autocomplete
              class="inline-input"
              v-model="fieldList[index].fieldType"
              :fetch-suggestions="querySearch"
              placeholder="请输入属性类型"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item>
            <el-input v-model="fieldList[index].fieldLength" placeholder="请输入属性长度" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item>
            <el-input v-model="fieldList[index].fieldAnnotation" placeholder="请输入属性介绍" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <i :class="index == 0 ? 'el-icon-circle-plus' : 'el-icon-remove'" style="font-size: 40px;" @click="changeItem(index)"></i>
      </el-row>

      <el-row>
        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="控制层" :label-width="formLabelWidth" prop="controller">
            <el-input v-model="controller" placeholder="请输入路径" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="服务层" :label-width="formLabelWidth" prop="service">
            <el-input v-model="service" placeholder="请输入路径" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="dao层" :label-width="formLabelWidth" prop="dao">
            <el-input v-model="dao" placeholder="请输入路径" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">
          <el-form-item label="文件类型" :label-width="formLabelWidth" prop="dao">
            <el-switch
              v-model="switch_entity"
              active-text="Entity">
            </el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item>
            <el-switch
              v-model="switch_controller"
              active-text="Controller">
            </el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item>
            <el-switch
              v-model="switch_service"
              active-text="Service">
            </el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item>
            <el-switch
              v-model="switch_dao"
              active-text="Dao">
            </el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item>
            <el-switch
              v-model="switch_vue"
              active-text="Vue">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-button type="primary" @click="generate">生成文件</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
  export default {
    data() {
      return {
        path: '',
        vuePath: '',
        componentPath: '',
        packagePath: '',
        author: '',
        role: '',
        bizName: '',
        entityName: '',
        fieldList: [
          {
            field: '',
            fieldType: '',
            fieldLength: '',
            fieldAnnotation: ''
          }
        ],
        controller: '',
        service: '',
        dao: '',
        role_list: [],
        typeList: [],
        formLabelWidth: '80px',
        switch_entity: true,
        switch_controller: true,
        switch_service: true,
        switch_dao: true,
        switch_vue: true
      };
    },
    methods: {
      querySearch(queryString, cb) {
        var typeList = this.typeList;
        var results = queryString ? typeList.filter(this.createFilter(queryString)) : typeList;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      loadAll() {
        return [
          { value: 'String'},
          { value: 'Long'},
          { value: 'Integer'},
          { value: 'Date'},
        ];
      },
      handleSelect(item) {
        console.log(item);
      },
      changeItem(index) {
        if(index == 0) {
          var field = {
            field: '',
            fieldType: '',
            fieldLength: '',
            fieldAnnotation: ''
          }
          this.fieldList.push(field)
        }else {
          this.fieldList.splice(this.fieldList.length - 1, 1)
        }
      },
      roleList() {
        this.axios({
          method: 'get',
          url: '/user/roleList',
        }).then(result => {
          this.role_list = result.data;
        }).catch(error => {
          console.log(error)
        })
      },
      generate() {
        this.axios.post('/template/generate', {
          path: this.path,
          vuePath: this.vuePath,
          componentPath: this.componentPath,
          packagePath: this.packagePath,
          author: this.author,
          permission: this.role,
          bizName: this.bizName,
          entityName: this.entityName,
          fieldList: this.fieldList,
          controller: this.controller,
          service: this.service,
          dao: this.dao,
          switchEntity: this.switch_entity,
          switchController: this.switch_controller,
          switchService: this.switch_service,
          switchDao: this.switch_dao,
          switchVue: this.switch_vue
        }).then(result => {
          this.$message(result.message);
        }).catch(error => {
          console.log(error)
        })
      }
    },
    watch: {
      'entityName': function(val) {
        let newVal = val.substring(0, 1).toUpperCase() + val.substring(1, val.length)
        this.entityName = newVal
        this.controller = newVal + 'Controller'
        this.service = newVal + 'Service'
        this.dao = newVal + 'Dao'
      }
    },
    mounted() {
      this.roleList()
      this.typeList = this.loadAll();
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/template/index.vue